import {
  Dialog,
  DialogBody,
  DialogTitle,
  DialogActions,
} from "V2.0/common/dialog";
import { Button } from "V2.0/common/button";
import { PlusIcon } from "@heroicons/react/24/outline";
import { useState } from "react";
import { Textarea } from "V2.0/common/textarea";
import { message } from "antd";
import { showErrorToast } from "V2.0/utils";

function NoteAdd(props) {
  const { onNoteAdd } = props;

  const [openNoteAdd, setOpenNoteAdd] = useState(false);
  const [note, setNote] = useState("");
  const [loading, setLoading] = useState(false);

  const handleAddNote = () => {
    const lifecycleCbs = {
      onInit: () => {
        setLoading(true);
        message.loading("Adding Note");
      },
      onSuccess: () => {
        setNote("");
        setLoading(false);
        message.destroy();
        message.success("Note added");
        setOpenNoteAdd(false);
      },
      onError: (e) => {
        setLoading(false);
        message.destroy();
        showErrorToast(e, "Failed to add note");
      },
    };
    onNoteAdd(note, lifecycleCbs);
  };

  const isAddDisabled = !Boolean(note);

  return (
    <>
      <Button onClick={() => setOpenNoteAdd(true)}>
        <PlusIcon /> Add Note
      </Button>
      <Dialog size="xl" open={openNoteAdd} onClose={() => setOpenNoteAdd(false)}>
        <DialogTitle>New Note</DialogTitle>
        <DialogBody>
          <Textarea
            style={{ height: "200px", fontSize: "13px" }}
            value={note}
            onChange={(e) => {
              e.stopPropagation();
              setNote(e.target.value);
            }}
          />
        </DialogBody>
        <DialogActions>
          <Button outline onClick={() => setOpenNoteAdd(false)}>
            Cancel
          </Button>
          <Button
            loading={loading}
            disabled={isAddDisabled}
            onClick={handleAddNote}
          >
            Add
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default NoteAdd;
